import { getExceptionFromAxiosError } from '@/client/helpers';
import { MessageResponseModel } from '@/client/models';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

export const accountOsintService = (client: AxiosInstance) => {
  const BASE_URL = (accountId: string) => `/accounts/${accountId}/osint`;

  const acceptDpa = async (
    accountId: string,
  ): Promise<MessageResponseModel> => {
    try {
      const result = await client.post<
        MessageResponseModel,
        AxiosResponse<MessageResponseModel>
      >(`${BASE_URL(accountId)}/accept-dpa`, {}, { withCredentials: true });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const withdrawDpa = async (
    accountId: string,
  ): Promise<MessageResponseModel> => {
    try {
      const result = await client.post<
        MessageResponseModel,
        AxiosResponse<MessageResponseModel>
      >(`${BASE_URL(accountId)}/withdraw-dpa`, {}, { withCredentials: true });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const getDpaDocument = async (
    accountId: string,
  ): Promise<{ downloadUrl: string }> => {
    try {
      const result = await client.get<
        { downloadUrl: string },
        AxiosResponse<{ downloadUrl: string }>
      >(`${BASE_URL(accountId)}/dpa-document`, { withCredentials: true });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return { acceptDpa, withdrawDpa, getDpaDocument };
};
